The event for the given `id`.
